<template>
    <aside id="appSidebarMenu" class="main-sidebar" v-show="$parent.sidebarLoaded ">
        <section class="sidebar">
            <ul class="sidebar-menu">
                <li v-if="branchName" style="color: wheat; font-size: 2rem; padding: 15px 15px 0 15px;">
                    <i class="fa-brands fa-git-alt"></i>
                    {{ branchName }}
                </li>

                <template v-for="(tab, index) in tabs['menu']">
                    <li :class="{
                            treeview: typeof tab.menu !== 'undefined',
                            active: ('/' + route.prefix === tab.href && active === index) || active === index,
                            'menu-open': opened === index,
                        }"
                        :id="'tab_'+index" v-on:click="toggleMenu(index, Boolean(tab.menu))">
                        <a :href="typeof tab.menu === 'undefined' ? '/'+user.service+tab.href : 'javascript: void(0);'">
                            <i v-if="tab.icon.split(/\s+/).length > 1"
                               style="width: 20px;padding-right: 9px;"
                               :class="tab.icon"
                            ></i>
                            <i v-else style="width: 20px;padding-right: 9px;" :class="'fas '+ tab.icon"></i>
                            {{ tab.text }}
                            <i v-if="typeof tab.menu !== 'undefined'" class="fa fa-angle-left pull-right"></i>
                            <small v-if="typeof badgesData[tab.href]!== 'undefined' && (badgesData[tab.href].count>0 || typeof badgesData[tab.href].count === 'string')"
                                   class="label pull-right" :class="'bg-'+badgesData[tab.href].color" tooltip="" :tooltip-color="badgesData[tab.href].color">
                                {{ badgesData[tab.href].count }}
                            </small>
                            <i v-else-if="typeof badgesData[tab.href ]!== 'undefined' && badges[tab.href].lock_icon"
                               :class="'pull-right text-'+badges[tab.href].color+' fas ' + badges[tab.href].lock_icon"/>
                        </a>
                        <ul v-if="typeof tab.menu !== 'undefined'" class="treeview-menu">
                            <li v-for="sub_tab in tab.menu" :class="'/'+route.path === sub_tab.href ? ' active' : ''"
                                @click="$event.stopPropagation()">
                                <a :href="'/'+ user.service + sub_tab.href">
                                    <i v-if="'/'+route.path === sub_tab.href" class="fas fa-circle-o fa-xs"></i>
                                    <i v-else class="far fa-circle fa-xs"></i>
                                    {{ sub_tab.text }}
                                    <small
                                        v-if="typeof badgesData[sub_tab.href]!== 'undefined' && (badgesData[sub_tab.href].count>0 || typeof badgesData[sub_tab.href].count === 'string')"
                                        class="label pull-right" :class="'bg-'+badges[tab.href].color" tooltip=""
                                        :tooltip-color="badgesData[sub_tab.href].color">
                                        {{ badgesData[sub_tab.href].count }}
                                    </small>
                                    <i v-else-if="typeof badgesData[sub_tab.href ]!== 'undefined' && badgesData[sub_tab.href].lock_icon"
                                       :class="'pull-right text-red fas ' + badgesData[sub_tab.href].lock_icon" style="margin-right: 8px"/>
                                </a>
                            </li>
                        </ul>
                    </li>
                </template>
            </ul>

            <div v-if="personalManager" class="managerBlock">
                <span class="managerTitle">Персональный менеджер:</span>
                <b>{{ personalManager.fio }}</b>
                <span v-if="personalManager.work_phone" style="display: block; margin: 5px 0">
                    <i class="fa fa-phone"></i>&nbsp{{ personalManager.workPhoneFormatted }}
                </span>
                <span v-if="personalManager.email" class="managerEmail" style="display: block; margin: 5px 0">
                    <i class="fa fa-envelope"></i>&nbsp
                    <a :href="'mailto:' + personalManager.email">{{ personalManager.email }}</a>
                </span>
            </div>
        </section>
    </aside>
</template>

<script>
export default {
    props: {
        badges: {},
        tabs: {},
        route: {},
        user: {},
        branchName: { type: String, default: null },
        personalManager: {},
    },
    data() {
        return {
            badgesData: this.badges,
            active: null,
            opened: null,
        }
    },

    created() {
        this.$bus.listen('updateMenu', () => {
            this.upd()
        })
    },

    mounted() {
        this.active = this.tabs['menu'].findIndex(item => {
            let hasActiveChild = false;

            if (item.menu) {
                Object.values(item.menu).forEach(subTab => {
                    if (subTab.href === '/' + this.route.prefix) {
                        hasActiveChild = true;
                    }
                });
            }

            return hasActiveChild || item.href === '/' + this.route.prefix;
        });

        this.$parent.sidebarLoaded = true;
    },

    methods: {
        toggleMenu(index, hasSubMenu = true) {
            if (!hasSubMenu) {
                this.active = index === this.active ? null : index;
            } else {
                this.opened = index === this.opened ? null : index;
            }
        },

        upd: function () {
            let scope = this;
            scope.axios.post('/' + window.location.pathname.match(/^\/(.*?)\//)[1] + '/badges', {}).then(function (data) {
                scope.badgesData = data.data;
                scope.$bus.fire('updatedBadges', scope.badgesData)
            })
        },
    }
}
</script>

<style>
.managerBlock {
    color: #b8c7ce;
    position: sticky;
    bottom: 0;
    background: #222d32;
    padding-left: 15px;
    padding-bottom: 35px;
    padding-top: 10px;
}
.withTopBanner .managerBlock {
    bottom: 50px;
}
.managerBlock .managerTitle {
    display: block;
    margin-bottom: 10px;
    color: white;
}
.managerBlock .managerEmail {
    word-break: break-all;
}
</style>
